(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-collection-list', {
            parent: 'entity',
            url: '/reporting-collection-list',
            data: {
                authorities: ['ROLE_READ_ONLY','ROLE_DATA_OPERATOR'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-collection-list/reporting-collection-list.html',
                    controller: 'ReportingCollectionListController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('contrat');
                    $translatePartialLoader.addPart('reportingCollectionList');
                    
                    return $translate.refresh();
                }]
            }
        });
    }

})();
